// Prices in their currency: coins, or gems (shared/gems.ts), the Market's real-money currency.
import type { MarketCurrency } from '../shared/market-query.ts';
import { iconUrl } from './assets.ts';
import { full } from './fmt.ts';

/** The painted gem (art/rig3d/icons/icon-gem.ts); client/assets.ts watchArtIcons swaps in the drawing for its size. */
export const GEM_ICON = 'art/icon-gem.png';

export const curIcon = (cur: MarketCurrency = 'coins') => (cur === 'gems' ? GEM_ICON : iconUrl('coin'));
export const curWord = (cur: MarketCurrency = 'coins', n = 2) => (cur === 'gems' ? (n === 1 ? 'gem' : 'gems') : n === 1 ? 'coin' : 'coins');

/** A price in its currency: the icon, then the amount. */
export const money = (n: number, cur: MarketCurrency = 'coins', cls = '') =>
  `<span class="mk-money${cur === 'gems' ? ' gem' : ''}${cls ? ` ${cls}` : ''}"><img src="${curIcon(cur)}" alt="${cur}">${full(n)}</span>`;
